export const METHOD_BALANCE_OF = 'balanceOf';
export const METHOD_TRANSFER = 'transfer';
export const METHOD_STAKE = 'stake'; // 위임
export const METHOD_UPDATE_REWARD = 'updateReward';
export const METHOD_ADD_REWARD_PERIOD = 'addRewardPeriod';
export const METHOD_CLAIM_REWARD = 'claimReward'; // 리워드 보상
export const METHOD_GET_INDIVIDUAL_REWARD = 'getIndividualReward';
export const METHOD_GET_TOTAL_REWARDS = 'getTotalRewards'; // 동일 지갑의 전체 보상을 조회합니다.
// 풀 설정관련 함수
export const METHOD_SET_POOL_NAME = 'setPoolName'; // 풀 이름
export const METHOD_SET_POOL_DESCRIPTION = 'setPoolDescription'; // 풀 설명
export const METHOD_STARTFUNDRAISING = 'startFundraising'; // 상태를 '모금 기간'으로 변경
// 모금 대기 상태에서만 설정 가능
export const METHOD_SETMINSTAKEAMOUNT = 'setMinStakeAmount'; // 최소 스테이킹 금액 (달러 기준)
export const METHOD_SET_INTEREST_RATE = 'setInterestRate'; // 이자율
export const METHOD_SET_FUNDRAISING_DURATION = 'setFundraisingDuration'; // 모금 기간
export const METHOD_SET_OPERATING_DURATION = 'setOperatingDuration'; // 운영 기간
export const METHOD_SET_MIN_FUNDRAISING_AMOUNT = 'setMinFundraisingAmount'; // 최소 모금 금액
export const METHOD_SET_MAX_FUNDRAISING_AMOUNT = 'setMaxFundraisingAmount'; // 최대 모금 금액
export const METHOD_SET_STAKING_TOKEN = 'setStakingToken'; // 스테이킹 대상 토큰 주소
// 모금 기간 관련 함수들
export const METHOD_STOP_FUNDRAISING = 'stopFundraising'; // 모금 중지 로직
export const METHOD_UNSTAKE_SFL = 'unstakeSFL';
export const METHOD_WITHDRAW_FAILED_FUNDRAISING = 'withdrawFailedFundraising'; // 모금 실패 시 자금 회수 로직
// 운영 기간 관련 함수들
export const METHOD_STOP_OPERATING = 'stopOperating'; // 운영 중지 로직
export const METHOD_VIEW_REWARDS = 'viewRewards'; // 보상 조회 로직
export const METHOD_VIEW_ACCUMULATED_REWARDS = 'viewAccumulatedRewards'; // 누적 보상 조회 로직
export const METHOD_REQUEST_REWARDS = 'requestRewards'; // 보상 요청 로직
export const METHOD_WITHDRAW_AT_CLOSURE = 'withdrawAtClosure'; // 운영 종료 시 자금 회수 로직
// 상태 변경 함수들
export const METHOD_START_OPERATING = 'startOperating'; // 상태를 '운영 기간'으로 변경하는 로직
export const METHOD_CLOSE_POOL = 'closePool'; // 스테이킹 풀을 종료하는 로직

// 사용자 함수
export const STAKKINGTOKEN = 'stakeToken'; // 토큰을 스테이킹합니다.
export const UNSTAKETOKEN = 'unStakeToken'; // 토큰을 언스테이킹합니다.
export const CLAIMREWARD = 'claimReward'; // 스테이킹 별 보상을 청구합니다.
export const WITHDRAWALLPRINCIPAL = 'withdrawAllPrincipal'; // 원금을 회수합니다.
export const CLAIMALLREWARD = 'claimAllReward'; // 사용자의 전체 보상을 요청합니다.
export const GETPOOLDETAILS = 'getPoolDetails'; // 풀의 세부사항을 조회합니다.
export const CALCULATEPENDINGREWARDFORSTAKE = 'calculatePendingRewardForStake'; // 사용자가 받을 보상 금액과 다음 인덱스를 조회합니다.
export const CALCULATEPENDINGREWARDFORALLSTAKES = 'calculatePendingRewardForAllStakes'; // 사용자가 받을 전체 보상 금액을 조회합니다. 풀의 상태가 `Operating`, `OperatingClosed`, 또는 `OperatingStopped`일 때만 호출할 수 있습니다.
export const CALCULATECLAIMEDREWARDFORALLSTAKES = 'calculateClaimedRewardForAllStakes'; // 사용자가 청구한 전체 보상 금액을 조회합니다.
export const GETTOTALSTAKEDAMOUNT = 'getTotalStakedAmount'; // 특정 사용자의 전체 스테이킹 금액을 조회합니다.
export const GETSTAKECOUNT = 'getStakeCount'; // 사용자의 스테이킹 개수를 조회합니다.
export const GETSTAKE = 'getStake'; // 사용자의 특정 스테이킹 정보를 조회합니다.
export const STATE = 'state'; // Pool 의 상태를 나타내는 열거형
// export const CALCULATEPENDINGREWARD = 'calculatePendingReward'; // 사용자가 받을 보상 금액과 다음 인덱스를 조회합니다.
export const CALCULATEALLPENDINGREWARD = 'calculateAllPendingReward'; // 사용자가 받을 전체 보상 금액을 조회합니다.
// export const CALCULATEALLCLAIMEDREWARD = 'calculateAllClaimedReward'; // 사용자가 청구한 전체 보상 금액을 조회합니다.
export const GETUSERSTAKECOUNT = 'getUserStakeCount'; // 사용자의 스테이킹 개수를 조회합니다.
export const REWARDSCHEDULE = 'rewardSchedules'; // 보상 스케줄을 정의하는 구조체
export const GETREWARDSCHEDULECOUNT = 'getRewardScheduleCount'; // 보상 스케줄의 개수를 얻어온다.
export const TOTALFUNDRAISINGMULTIPLIEDPRICE = 'totalFundraisingMultipliedPrice' // 총 모금 금액 (ex. 총 모금액이 $100 인 경우 실제 값은 100 x PRICE_MULTIPLIER)